import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import parsePhoneNumber from 'libphonenumber-js';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { useDinerAccount } from 'reservations/dinerAccount/hooks/useDinerAccount';

const DinerInformationReadOnly = ({ sxOverride = {} }) => {
  const { dinerEmail, dinerName, dinerPhone, formattedDinerPhone } =
    useDinerAccount();
  const { setValue } = useFormContext();
  const parsedPhone = parsePhoneNumber(dinerPhone);

  useEffect(() => {
    setValue('email', dinerEmail);
    setValue('fullPhoneNumber', dinerPhone);
    setValue('name', dinerName);
    setValue('phone', parsedPhone?.nationalNumber);
    setValue('phoneCode', parsedPhone?.countryCallingCode);
  }, []);

  const ReadOnlyField = ({ text }: { text: string }) => (
    <Typography sx={{ fontSize: '16px', ...sxOverride }}>{text}</Typography>
  );
  const ReadOnlyFields = [dinerName, dinerEmail, formattedDinerPhone].map(
    text => <ReadOnlyField key={text} text={text} />
  );

  return <Box data-testid="diner-information-read-only">{ReadOnlyFields}</Box>;
};

export default DinerInformationReadOnly;
